module.exports = __webpack_public_path__ + "img/code-01.2cc67634.svg";